import LabServiceModel from "@/models/LabServiceModel";
import LaboratoryModel from "@/models/lab/LaboratoryModel";
import SampleTypeModel from "@/models/lab/SampleTypeModel";

export default class ServiceQuestionModel extends LabServiceModel {
  modelName() {
    return 'service-question';
  }
  defaults() {
    return {
      id: null,
      laboratory_id: null,
      laboratory: null,
      sample_type_id: null,
      sample_type: null,
      form_level: null,
      input_type: null,
      label: null,
      values: null,
      created_at: null,
      updated_at: null,
      deleted_at: null,
    }
  }
  mutations() {
    return {
      id: (val) => (this.nullStringMutator(val)),
      laboratory_id: (val) => (this.nullStringMutator(val)),
      sample_type_id: (val) => (this.nullStringMutator(val)),
      form_level: (val) => (this.nullStringMutator(val)),
      input_type: (val) => (this.nullStringMutator(val)),
      label: (val) => (this.nullStringMutator(val)),
      values: (val) => (this.nullStringMutator(val)),
      created_at: String,
      updated_at: String,
      deleted_at: String,
    }
  }
  validation() {
    return {}
  }
  getLaboratory() {
    return this.getRelatedModel(LaboratoryModel, 'laboratory');
  }
  getSampleType() {
    return this.getRelatedModel(SampleTypeModel, 'sample_type');
  }
}
